import React, { useState, useEffect, useReducer } from "react"
import {Tabs, Tab, Box, Typography} from "@mui/material"
import Users from "../containers/AdminstrationContainers/UsersContainer/Users"
import Access from "../containers/AdminstrationContainers/AccessContainers/Access";
import { useDispatch, useSelector } from "react-redux";
import CompanyInfo from "../containers/AdminstrationContainers/CompanyInfoContainer/CompanyInfo";
import ImportProducts from "../containers/AdminstrationContainers/ImportContainers/ImportProducts";
import { Button } from "@material-ui/core";
import Register from "../utils/Register";
import {MdAdd} from "react-icons/md"
import { setUsers, updateUser } from "../redux/actions/usersActions";
import useFetch from "../funcrions/DataFetchers";
import {BiArrowBack} from "react-icons/bi"
import Transactions from "../containers/AdminstrationContainers/UsersContainer/Transactions"
import UsersCustomers from "../containers/AdminstrationContainers/UsersContainer/UsersCustomers";
import UsersVendors from "../containers/AdminstrationContainers/UsersContainer/UserVendors";
import SendUserSms from "../containers/AdminstrationContainers/SendUserSms";
import axios from "axios";
import { constants } from "../Helpers/constantsFile";
import UploadLogo from "../containers/AdminstrationContainers/uploadLogo";

const Adminstration = () => {

  const fields  = [
    { label: "Enter Name", type: "text", name: "name" },
    { label: "Enter username", type: "text", name: "username" },
    { label: "Enter phone", type: "number", name: "phone" },
    { label: "Enter Fee", type: "number", name: "fee" },
    { label: "Geli Number Labaad", type: "number", name: "businessNumber" },
    { label: "Geli Goobta", type: "text", name: "businessLocation" },
    { label: "Nuuca Macaamiilka", type: "text", name: "usageType" },
    { label: "Registration Fee", type: "text", name: "registrationFee" },
    { label: "Admin Password", type: "text", name: "specialPassword" },
    { label: "Merchant", type: "text", name: "smsSuffix" },
  ];

  const statusArr = ["All", "Active", "Inactive"]
  const activeUser = useSelector(state => state.activeUser.activeUser)

  const [value, setValue] = React.useState("users");
  const [newUser, setNewUser] = useState(false)
  const [showTransactions, setShowTransactions] = useState(false);
  const [showCustomers, setShowCustomers] = useState(false)
  const [showVendors, setShowVendors] = useState(false)
  const [instance, setInstance] = useState();
  const [buttonName, setButtonName] = useState("Add New Users");
  const [update, setUpdate] = useState(false)
  const [updatedUser, setUpdatedUser] = useState()
  const [smsModal, setSmsModal] = useState(false)
  const [uploadModal, setUploadModal] = useState(false)

  const token = useSelector(state => state.token.token)


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };



  const addHandler = () => {
    if (buttonName == "Add New Users") {
      setNewUser(true)
      setButtonName("Go To Users");
      setShowTransactions(false);
      setShowCustomers(false)
      return;
    } else if (buttonName == "Go To Users") {
      setShowTransactions(false);
      setShowCustomers(false);
      setShowVendors(false);
      setButtonName("Add New Users");
    }
  };

  const [change, setChange] = useState(1)
  const [myChange, setMyChange] = useState(1)
  const dispatch = useDispatch()

  const changeHandler = (data) => {
    dispatch(updateUser(data.user))
    setChange(state => state + 1)
  }

  const handleSendSms = (sms) => {

    axios
      .post(
        `${constants.baseUrl}/sms/custom-sms`,
        {
          "smsUserName": "tacabtire",
          "smsPassword": "mj1w7fWibNis7p1zvlJRkQ==",
          "customers": [instance],
          "senderId": "TACABTIRE",
          "userId": "63b197b37f5f1674109bf22a",
          "userPassword": "12345",
          // "message": ", Fadlan iska bixi lacagta bisha intuusan isxerin (DEENTIRE) Maanta. Mahadsanid. 06/08/2024"
          "message": sms
          },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        alert("Successfully sent sms")
        console.log(res?.data?.data)
      })
      .catch((err) => {
        alert(err?.response?.data?.message);
        console.log(err)
      });
  }

  dispatch(setUsers(useFetch("users", change, "users")))
  
  useEffect(() => {
    console.log(`chang is happening ${change}`)
  })
  
  return (
    <div
    style={{
      display: "flex",
      height: "100%",
      width: "100%",
      margin: "0px auto",
      gap: "0px",
      flexDirection: "column",
    }}
  >
    <div style = {{display: "flex", width: "95%", margin: "auto",
  justifyContent: "space-between"}}>
     <Typography style = {{fontWeight: "bold", 
    fontSize: "23px"}}> Adminstration</Typography>
        {value == "users" && 
         <Button
         variant="contained"
         style={{
           backgroundColor: "#19274B",
           color: "white",
           width: "220px",
           height: "45px",
           fontWeight: "bold"
         }}
         onClick={() => {
             addHandler();
         }}
         startIcon={
           newUser || showTransactions || showCustomers || showVendors ? (
             <BiArrowBack
               style={{
                 color: "white",
               }}
             />
           ) : (
             <MdAdd
               style={{
                 color: "white",
               }}
             />
           )
         }
       >
         {buttonName}
       </Button>
        }

        </div>
        {showTransactions && <Transactions instance={instance} name="customer" />}
        {showCustomers && <UsersCustomers instance={instance} name="customer"/>}
        {showVendors && <UsersVendors instance={instance} name="vendor"/>}

    {(value == "users" && !showTransactions && !showCustomers && !showVendors ) 
    && <Users key = {change}

    showTransactions={(instance) => {
      setShowTransactions(true);
      setInstance(instance);
      setButtonName("Go To Users");
    }}

    showCustomers={(instance) => {
      setShowCustomers(true);
      setInstance(instance);
      setButtonName("Go To Users");
    }}

    showVendors={(instance) => {
      setShowVendors(true);
      setInstance(instance);
      setButtonName("Go To Users");
    }}

    updateUser = {(user, type)=> {
      if (type == "side") {
        
      }
      setNewUser(true);
    setButtonName("Go To Users");
    setUpdate(true);
    setUpdatedUser(user);
    }}
    sendUserSms = {(user) => {
      setSmsModal(true)
      setInstance(user)
    }}
    uploadModal = {(user) => {
      setUploadModal(true)
      setInstance(user)
    }}
    />}

    {smsModal && <SendUserSms open = {smsModal} user = {instance} hideModal = {()=> {
      setSmsModal(false)
      setInstance()
    }} onSend={(sms) => handleSendSms(sms)}/>}
    {uploadModal && <UploadLogo open = {uploadModal}  id = {instance._id} handleClose = {()=> {
      setUploadModal(false)
      setInstance()
    }} />}
          
    {value == "access" && <Access/>}

    {newUser && (
        <Register
        instance = {updatedUser}
          update = {update}
          hideModal={() => {
            setNewUser(false)
            setButtonName("Add New Users")
            setUpdate(false)
          }}
          fields={fields}
          url="users"
          name="User"
          change={(data)=> changeHandler(data)}
        />
      )}
    </div>
  );
};

export default Adminstration;
